<script lang="ts" setup>
import { z } from 'zod'

const toast = useToast()


const loading = ref(false)
const schema = z.object({
  email: z
    .string({ required_error: 'Požadované' })
    .email('Neplatný email'),
  password: z
    .string({ required_error: 'Požadované' })
    .min(8, 'Musí mít alespoň 8 znaků'),
  apiKey: z
    .string({ required_error: 'Požadované' })
})

const state = ref({
  email: undefined,
  password: undefined,
  apiKey: undefined,
})

async function onSubmit(event) {
  try {
    loading.value = true
    event.data.name = "Tobe Removed"
    await $fetch('/api/auth/register', { method: 'POST', body: event.data })
    toast.add({
      id: `account_created`,
      title: `Účet byl úspěšně vytvořen.`,
      icon: 'i-heroicons-check-circle',
      timeout: 5000,
      color: 'green',
    })
    return navigateTo(
      `/auth/verify-otp?email=${encodeURIComponent(state.value.email)}&type=SIGNUP`
    )
  } catch (error) {
    loading.value = false
    if (error.data && error.data.data && error.data.data.name === 'ZodError') {
      const issues = error.data.data.issues
        .map((issue) => {
          const path = issue.path.join('.')
          return `Invalid ${path}: ${issue.message}`
        })
        .join('\n')
      consola.log(issues)
    }
    toast.add({
      id: `account_creation_error`,
      title: `Vytvoření účtu nebylo úspěšné.`,
      icon: 'i-heroicons-x-circle',
      timeout: 5000,
      color: 'red',
    })
    // toast.error(error.data ? error.data.statusMessage : 'An unknown error occurred')
  }
}
</script>

<template>
  <UForm :schema="schema" :state="state" class="space-y-4" @submit="onSubmit">
    <UFormGroup name="email" size="lg" required>
      <template #label>
        <UIcon
          name="heroicons:envelope"
          class="-mb-1 h-5 w-5 text-gray-400"
        />
        <span class="mx-1">Email</span>
      </template>
      <UInput v-model="state.email" class="mt-1"/>
    </UFormGroup>
    <UFormGroup name="password" size="lg" required>
      <template #label>
        <UIcon
          name="i-heroicons-lock-closed"
          class="-mb-1 h-5 w-5 text-gray-400"
        />
        <span class="mx-1">Heslo</span>
      </template>
      <UInput v-model="state.password" type="password" class="mt-1" />
    </UFormGroup>
    <UFormGroup name="apiKey" size="lg" required>
      <template #label>
        <UIcon
          name="i-heroicons-key"
          class="-mb-1 h-5 w-5 text-gray-400"
        />
        <span class="mx-1">Redmine API klíč</span>
      </template>
      <UInput v-model="state.apiKey" class="mt-1"/>
    </UFormGroup>
    <UButton
      block
      color="orange"
      type="submit"
      size="lg"
      :loading="loading"
      :disabled="loading"
    >
      Vytvořit účet
    </UButton>
  </UForm>
</template>
